
import { useState } from 'react';
import './App.css';
import CanvasCut from './component/CanvasCut';
import LinkImage from './component/LinkImage';
import QuantityGrid from './component/QuantityGrid';
import UploadFile from './component/UploadFile';
import Switch from './component/Switch';

let sizeObj = {w:'',h:''};
function App() {
  const [grids,setGrid] = useState(100);
  const [imageUrl, setImageUrl] = useState(null);
  const [arrSplice, setArrSplice] = useState([]);
  const [sizeImages, setSizeImages] = useState(sizeObj);
  const [gridSize, setGridSize] = useState(1);
  const [typeGrid, setTypeGrid] = useState('grid');
  const grid = (grid, gridSize) => {
    setGrid(grid);
    setGridSize(gridSize);
    setArrSplice([]);
    return grids ;
  }

  const srcImage = (url) => {
    setImageUrl(url);
  }

  const dataArr = (arr) => {
    setArrSplice(arr);
  }
  const sizeImage = (obj) => {
    setSizeImages(obj);
  }
  const typeGridChange = (type) =>{
    setTypeGrid(type);
    setArrSplice([]);
    console.log(type);
  }
  return(
      <div className='c_container'>
        <div className='uploade-wrapper'>
          <UploadFile grid={grids} urlImage={srcImage} sizeImage={sizeImage} dataType={typeGrid}/>
          <div className='button-body'>
            <QuantityGrid grid={grid} />
            <Switch dataType={typeGrid} typeChange={typeGridChange}/>
            <CanvasCut width="480" height="320" urlImage={imageUrl} dataArr={dataArr} sizeImage={sizeImages} grid={gridSize} dataType={typeGrid}/>
          </div>
        </div>
      <LinkImage arr={arrSplice} dataSize={gridSize} dataType={typeGrid}/>
      </div>
  );
}

export default App;
